import {
  LearningTemplatePackageBase,
  LearningTemplatePackageDistributionHistoryBase,
  LearningTemplatePackageFrameListBase,
  PackagingAsLearningTemplatePackageBase,
} from "@lib/Api";

export enum LearningTemplateHistoryModalKind {
  IDLE = "idle",
  SHOW = "show",
  EDIT = "edit",
  DELETE = "delete",
}

export type LearningTemplateHistoryModalType = {
  isOpen: boolean;
  kind: LearningTemplateHistoryModalKind;
  learningTemplatePackage: LearningTemplatePackageDistributionHistoryBase | null;
};

export enum ModalStatus {
  CREATE_TEMPLATE = "create",
  EDIT_TEMPLATE = "edit",
  DELETE_TEMPLATE = "delete_template",
  ADD_PACKAGE = "add",
  EDIT_ADDED_PACKAGE = "edit_added_package",
  DELETE_PACKAGE = "delete_package",
  DELETE_CO_PACKAGE = "delete_co_package",
  DISTRIBUTION = "distribution",
  IDLE = "idle",
  DELETE_FRAME = "delete_frame",
}
export interface ModalStateParams {
  isOpen: boolean;
  learningTemplate: LearningTemplatePackageBase | null;
  package: PackagingAsLearningTemplatePackageBase | null;
  packagesArray: PackagingAsLearningTemplatePackageBase[] | null;
  status: ModalStatus;
  coPackage?: PackagingAsLearningTemplatePackageBase | null;
  learningTemplateFrame?: LearningTemplatePackageFrameListBase | null;
  isPackageInFrame?: boolean;
  frameIndex?: number;
}
export type ModalOpenParams = {
  modalStatus: ModalStatus;
  learningTemplate?: LearningTemplatePackageBase;
  packaging?: PackagingAsLearningTemplatePackageBase;
  packagesArray?: PackagingAsLearningTemplatePackageBase[];
  learningTemplateFrame?: LearningTemplatePackageFrameListBase;
  isPackageInFrame?: boolean;
  frameIndex?: number;
};
